/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react';
import { useFetchStockOptions, useFetchExpiryDates } from '../services/stock.service';
import { useFetchMitStocks, useFetchTopBestContracts } from '../services/mit.service';
import { OptionData, StockData, TopBestContracts, StockExpiryDateData } from '../types/stock';
import { formatDateTime, formatPrice, formatNumber, isNotNullUndefined } from '../helpers/common';
import { useNavigate } from 'react-router-dom';
import { Select, Slider, Pagination, DatePicker, Space, QRCode } from 'antd';
import { DownCircleOutlined, LeftCircleOutlined, ReloadOutlined } from '@ant-design/icons';
import Images from '../assets/images';
import { storage } from '../utils/storage';
import Search from 'antd/es/input/Search';
import { IResponseModel } from '../types/response';
import dayjs from 'dayjs';

const Mitmobile = () => {
    const navigate = useNavigate();
    const preservedStockOptionData = useRef<OptionData[]>([]);
    const [stockOptionData, setStockOptionData] = useState<OptionData[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [activeTab, setActiveTab] = useState("other");
    const [totalItems, setTotalItems] = useState<number>(0);
    const isAuthenticated = useRef(false);
    const isGuestUser = useRef(false);
    const [stockSymbol, setStockSymbol] = useState<string>("");
    const [expirationDate, setExpiryDate] = useState<string>("");
    const [stocks, setMitStocksList] = useState<any[]>([]);
    const [expiryDates, setExpiryDatesList] = useState<any[]>([]);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const defaultPageSize = 20;
    const [pageSize, setPageSize] = useState<number>(defaultPageSize);
    const defaultScoreRange: [number, number] = [100, 1000];
    const [significanceScoreRange, setSignificanceScoreRange] = useState<[number, number]>(defaultScoreRange);
    const [aiScoreMarks, setAIScoreMarks] = useState<any>({});
    const [dateRange, setDateRange] = useState(["", ""]);
    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const [expandedRowIndex, setExpandedRowIndex] = useState(null);
    const [selectedTradingType, setSelectedTradingType] = useState('spot');
    const [stockSymbolOpen, setStockSymbolOpen] = useState(false);
    const [expiryDateOpen, setExpiryDateOpen] = useState(false);
    const { RangePicker } = DatePicker;
    const topContractsData = useRef<TopBestContracts[]>([]);
    const [todayTopContractData, setTodayTopContractsData] = useState<TopBestContracts[]>([]);
    const [topRecentContractData, setRecentTopContractsData] = useState<TopBestContracts[]>([]);
    const [isLoading, setIsLoading] = useState<{ [key: number]: boolean }>({});
    const [isOpen, setIsOpen] = useState<Record<number, boolean>>({});
    const [showSharePopup, setShowSharePopup] = useState(false);
    const token = useRef("");
    const [showSignInPopup, setShowSignInPopup] = useState(false);
    const [scrollHeight, setScrollHeight] = useState("");
    const [imageUrl, setImageUrl] = useState<any>(null);
    const [contractType, setContractType] = useState<any>(null);
    const [parentStockSymbol, setParentStockSymbol] = useState<any>(null);
    const [companyName, setCompanyName] = useState<any>(null);
    const [potentialGain, setPotentialGain] = useState<any>(null);
    const [spotPrice, setSpotPrice] = useState<any>(null);
    const [spotTargetPrice, setSpotTargetPrice] = useState<any>(null);
    const [spotPercentageGain, setSpotPercentageGain] = useState<any>(null);
    const [contractName, setContractName] = useState<any>(null);
    const [optionPrice, setOptionPrice] = useState<any>(null);
    const [optionTargetPrice, setOptionTargetPrice] = useState<any>(null);
    const [optionPercentageGain, setOptionPercentageGain] = useState<any>(null);
    const [todayOptionInvested, setTodayOptionInvested] = useState<any>(null);
    const [todayContractPercentage, settodayContractPercentage] = useState<any>(null);
    const [todayPutCallRatio, settodayPutCallRatio] = useState<any>(null);
    const [pcr, setPCR] = useState<any>(null);
    const substringsToRemove = ["Class A Common Stock", "Common Stock"];
    const isSyncInProgress = useRef(false);

    const getMitStocksList = useFetchMitStocks({
        onSuccess: (response: IResponseModel<StockData>) => {
            if (response.statusCode === 200) {
                const options = response.data.map((stock: { stockSymbol: string; }) => ({
                    label: stock.stockSymbol,
                    value: stock.stockSymbol,
                }));
                setMitStocksList(options);
            }
            else {
                setMitStocksList([]);
            }
        },
    });

    const getExpiryDatesList = useFetchExpiryDates({
        onSuccess: (response: IResponseModel<StockExpiryDateData>) => {
            if (response.statusCode === 200) {
                const options = response.data.map((expiryDate: { expirationDate: string; }) => ({
                    label: formatDateTime(new Date(expiryDate.expirationDate), "DD-MMS-YYYY"),
                    value: expiryDate.expirationDate,
                }));
                setExpiryDatesList(options);
            }
            else {
                setExpiryDatesList([]);
            }
        },
    });

    const getStockOptionsDetails = useFetchStockOptions({
        onSuccess: (response: IResponseModel<OptionData>) => {
            if (response.statusCode === 200) {
                const formattedData = response.data.map((item: any, index: { toString: () => any; }) => ({
                    ...item,
                    key: index.toString(),
                }));
                preservedStockOptionData.current = formattedData;
                if (response.data.length > 0 && isNotNullUndefined(response.data[0].recordCount)) {
                    setStockOptionData(formattedData);
                    setTotalItems(response.data[0].recordCount);
                } else {
                    resetPagination();
                }
                setLoading(false);
            }
            else {
                resetPagination();
                setLoading(false);
            }
        },
    });

    const resetPagination = () => {
        setStockOptionData([]);
        setCurrentPage(1);
        setPageSize(defaultPageSize);
        setTotalItems(0);
    };

    const prepareStockOptionDetailsParams = (page: number, pageSize: number) => ({
        stockSymbols: stockSymbol,
        significanceScoreRange: significanceScoreRange.join('-'),
        eventDateFrom: dateRange[0],
        eventDateTo: dateRange[1],
        expiryDate: expirationDate || '',
        isGuestUser: isGuestUser.current,
        pageNumber: page,
        pageSize: pageSize
    });

    const fetchOptionsData = () => {
        setLoading(true);
        setStockOptionData([]);
        const requestParams = prepareStockOptionDetailsParams(currentPage, pageSize);
        getStockOptionsDetails.mutate(requestParams);
    };

    const fetchMitStocksList = () => {
        getMitStocksList.mutate({});
    }

    const fetchExpiryDatesList = () => {
        getExpiryDatesList.mutate({});
    }

    const handlePageChange = (page: number, pageSize: number) => {
        setCurrentPage(page);
        setPageSize(pageSize);
    };

    const handleDateChange = (_: any, dateStrings: any) => {
        resetPagination();
        setDateRange(dateStrings);
    }

    const handleSliderChange = (value: any) => {
        setSignificanceScoreRange(value);
    };

    const handleStockSymbolChange = (value: any) => {
        resetPagination();
        setStockSymbol(value?.join(','));
        if (value.length >= 1) {
            setStockSymbolOpen(false);
        }
    };

    const handleExpiryDateChange = (value: any) => {
        resetPagination();
        if (value) {
            setExpiryDate(value);
        } else {
            setExpiryDate('');
        }
        setExpiryDateOpen(false);
    };

    const onRefresh = () => {
        setLoading(true);
        fetchOptionsData();
    }

    const handleSharePopup = (event: any, selectedItem: any) => {
        event.stopPropagation();
        setShowSharePopup((prev) => !prev);
        if (!selectedItem) {
            console.warn("No item provided.");
            return;
        }
        setImageUrl(selectedItem.imageUrl);
        setContractType(selectedItem.contractType);
        setParentStockSymbol(selectedItem.parentStockSymbol);
        const pattern = new RegExp(substringsToRemove.join('|'), 'gi');
        const updatedCompanyName = selectedItem.companyName.replace(pattern, '').trim();
        setCompanyName(updatedCompanyName);
        setPotentialGain(selectedItem.potentialGain);
        setSpotPrice(selectedItem.spotPrice);
        setSpotTargetPrice(selectedItem.spotTargetPrice);
        setSpotPercentageGain(selectedItem.spotPercentageGain);
        setContractName(selectedItem.contractName);
        setOptionPrice(selectedItem.optionPrice);
        setOptionTargetPrice(selectedItem.optionTargetPrice);
        setOptionPercentageGain(selectedItem.optionPercentageGain);
        setTodayOptionInvested(selectedItem.todayOptionInvested);
        settodayContractPercentage(selectedItem.todayContractPercentage);
        settodayPutCallRatio(selectedItem.todayPutCallRatio);
        setPCR(selectedItem.pcr);
    }

    const onSearchContractName = (event: any) => {
        const searchValue = event.target.value.trim().toLowerCase();
        if (searchValue.length >= 2) {
            const filteredData = preservedStockOptionData.current.filter(x => x.contractName.toLowerCase().includes(searchValue));
            setStockOptionData(filteredData);
        } else {
            setStockOptionData(preservedStockOptionData.current);
        }
    }

    useEffect(() => {
        const [min, max] = significanceScoreRange;
        const newMarks = {
            [min]: `${min}`,
            [max]: `${max}`,
        };
        setAIScoreMarks(newMarks);
    }, [significanceScoreRange]);

    const syncAuthAndFetchData = () => {
        if (isSyncInProgress.current) {
            return;
        }
        isSyncInProgress.current = true;
        const [isAuth, isGuest] = ["isAuthenticated", "isGuestUser"].map(key =>
            JSON.parse(storage.getLocalProperty(key) ?? "false")
        );

        isAuthenticated.current = isAuth;
        isGuestUser.current = isGuest;
        token.current = (isGuest || isAuth) ? storage.getToken() : "";
        if (token.current !== "") {
            fetchMitStocksList();
            fetchExpiryDatesList();
            isSyncInProgress.current = false;
        }
        else {
            setTimeout(() => {
                isSyncInProgress.current = false;
                syncAuthAndFetchData();
            }, 100);
        }
    };

    useEffect(() => {
        if (token.current !== "" && !isSyncInProgress.current) {
            fetchOptionsData();
        } else {
            syncAuthAndFetchData();
        }
    }, [stockSymbol, expirationDate, dateRange, currentPage, pageSize, token.current]);

    useEffect(() => {
        window.addEventListener("authStateChanged", syncAuthAndFetchData);
        return () => {
            window.removeEventListener("authStateChanged", syncAuthAndFetchData);
        };
    }, []); // Ensure event listener is added only once

    const handleRowClick = (index: any) => {
        setExpandedRowIndex(expandedRowIndex === index ? null : index);
        setSelectedTradingType('spot');
        isGuestUser.current = JSON.parse(storage.getLocalProperty("isGuestUser") ?? false);
        isAuthenticated.current = JSON.parse(storage.getLocalProperty("isAuthenticated") ?? false);
        if (isGuestUser.current) {
            (expandedRowIndex !== index) ?
                setShowSignInPopup(!false)
                : setShowSignInPopup(!showSignInPopup)
        }
        setIsOpen((prevState) => ({
            ...prevState,
            [index]: !prevState[index], // Toggle open/close for the specific index
        }));

        if (index !== null && stockOptionData[index]?.parentStockSymbol) {
            const symbol = stockOptionData[index]?.parentStockSymbol;
            const tradeDate = stockOptionData[index]?.tradeDate;
            setIsLoading((prev) => ({ ...prev, [index]: true }));

            try {
                fetchTopBestContracts(index, symbol, tradeDate);
            } catch (error) {
                console.error('Error fetching contracts:', error);
            } finally {
                setIsLoading((prev) => ({ ...prev, [index]: true }));
            }
        }
    };

    const fetchTopBestContracts = (index: any, symbol: any, tradeDate: any) => {
        getTopBestContracts.mutate({
            stockSymbols: symbol,
            tradeDate: tradeDate,
        }, {
            onSuccess: () => {
                setIsLoading((prev) => ({ ...prev, [index]: false }));
            },
            onError: () => {
                setIsLoading((prev) => ({ ...prev, [index]: false }));
            }
        });
    };

    const getTopBestContracts = useFetchTopBestContracts({
        onSuccess: (response: IResponseModel<TopBestContracts>) => {
            if (response.statusCode === 200) {
                const formattedData = response.data.map((item: TopBestContracts, index: number) => ({
                    ...item,
                    key: index.toString(),
                }));
                const todayData = formattedData.filter((item) => item.day === 'Today');
                const recentData = formattedData.filter((item) => item.day === 'Recent');
                setTodayTopContractsData(todayData);
                setRecentTopContractsData(recentData);
                topContractsData.current = formattedData;
            } else {
                setTodayTopContractsData([]);
                setRecentTopContractsData([]);
            }
        },
    });

    useEffect(() => {
        if (!isGuestUser.current) {
            // User signed in hai
            setScrollHeight(isFilterOpen ?
                "h-[calc(100vh-390px)] md:h-[calc(100vh-px)]" :
                "h-[calc(100vh-130px)] md:h-[calc(100vh-130px)]"
            );
        } else {
            // Guest user hai
            setScrollHeight(isFilterOpen ?
                "h-[calc(100vh-535px)] md:h-[calc(100vh-227px)]" :
                "h-[calc(100vh-267px)] md:h-[calc(100vh-130px)]"
            );
        }
    }, [isGuestUser.current, isFilterOpen]);
    const TradingViewChart = ({ symbol }: any) => {
        const containerRef = useRef<HTMLDivElement | any>('');

        useEffect(() => {
            if (containerRef.current) {
                const script = document.createElement('script');
                script.src = 'https://s3.tradingview.com/tv.js';
                script.async = true;

                script.onload = () => {
                    setTimeout(() => {
                        if (containerRef.current) {
                            new window.TradingView.widget({
                                symbol: symbol || 'SAVA',
                                interval: 'D',
                                width: '100%',
                                height: '500',
                                container_id: containerRef.current.id,
                                allow_symbol_change: true,
                                hide_top_toolbar: true,
                                hide_legend: true,
                            });
                        }
                    }, 0);
                };
                document.head.appendChild(script);

                return () => {
                    document.head.removeChild(script);
                    if (containerRef.current) {
                        containerRef.current.innerHTML = '';
                    }
                };
            }
        }, [symbol]);

        return (
            <div ref={containerRef} id={`tradingview-chart-${symbol}`} />
        );
    };

    const RowSignInPopup = ({ index, onClose }: any) => {
        return (
            <div className="inline-block bg-white p-4 md:p-6 rounded-lg shadow-lg text-center">
                <p className="text-base md:text-lg font-semibold mb-4">
                    Please Sign In to unlock real-time data.
                </p>
                <button
                    onClick={() => onClose(index)}
                    className="mt-2 py-2 px-4 text-xs lg:text-base text-white border border-blue-midnight bg-blue-midnight rounded hover:bg-transparent hover:text-blue-midnight transition"
                > Okay </button>
            </div>
        );
    };

    const disableFutureAndToday = (current: any) => {
        if (isGuestUser.current) {
            return current && current >= dayjs().startOf('day');
        }
        return false;
    };

    return (
        <div>
            <div className="sticky z-10 bg-white p-3 shadow-md top-0">
                <div className='flex items-center gap-2 ml-7'>
                    {/* Filter Button - Visible only on mobile */}
                    <button
                        onClick={() => setIsFilterOpen(!isFilterOpen)} // Toggle the filter section
                        className="py-[5px] px-2 lg:py-2 lg:px-4 text-black border border-blue-midnight text-sm rounded-md flex items-center justify-between gap-1.5 w-full"
                    >
                        Filter
                        {/* Conditional Icon Rendering */}
                        {isFilterOpen ? (
                            <DownCircleOutlined className="text-blue-midnight" />
                        ) : (
                            <LeftCircleOutlined className="text-blue-midnight" />
                        )}
                    </button>
                    <div>
                        <button
                            onClick={() => {
                                onRefresh();
                            }}
                            className="py-2 px-2 lg:px-4 text-xs lg:text-base lg:py-2 text-white border border-blue-midnight bg-blue-midnight rounded hover:bg-transparent hover:text-blue-midnight flex items-center gap-1.5"
                        >
                            <ReloadOutlined />
                            {loading ? "Loading..." : "Refresh"}
                        </button>
                    </div>
                </div>
                {isFilterOpen && (
                    <div className='block md:items-center md:flex gap-4 w-full justify-end bg-white rounded-lg mt-2 p-2 pb-0 sm:p-3.5'>
                        <div className='lg:flex gap-4 items-center w-full justify-end'>
                            <div>
                                <Search placeholder="Search Contract Name" allowClear onChange={onSearchContractName} className='w-full text-start mit-searchbar' />
                            </div>
                            <div>
                                <Select
                                    allowClear
                                    className='w-full min-w-60 md:max-w-[600px] text-start multi-user-dropdown mt-2 h-10'
                                    placeholder="Select Expiry Date"
                                    onChange={handleExpiryDateChange}
                                    options={expiryDates}
                                    open={expiryDateOpen}
                                    onDropdownVisibleChange={(visible) => setExpiryDateOpen(visible)}
                                />
                            </div>
                            <div>
                                <Space direction="vertical" size={12} className='w-full my-2 lg:my-0'>
                                    <RangePicker
                                        onChange={handleDateChange}
                                        className='p-2 w-full datepicker-table'
                                        disabledDate={disableFutureAndToday}
                                    />
                                </Space>
                            </div>
                            <div>
                                <Select
                                    mode="multiple"
                                    allowClear
                                    className='w-full min-w-80 md:max-w-[600px] text-start multi-user-dropdown'
                                    placeholder="Select Stock Symbol" //"Select Companies"
                                    onChange={handleStockSymbolChange}
                                    options={stocks}
                                    open={stockSymbolOpen} // Control dropdown visibility
                                    onDropdownVisibleChange={(visible) => setStockSymbolOpen(visible)} // Update open state on dropdown visibility change
                                />
                            </div>
                        </div>
                        <div className='flex justify-between items-center gap-8 mt-2 md:mt-0'>
                            <div className='max-md:w-[95%]'>
                                <p className='absolute text-sm font-semibold '>Open AI Score</p>
                                <Slider range
                                    value={significanceScoreRange}
                                    marks={aiScoreMarks}
                                    min={1} max={1000}
                                    onChange={(evt) => { handleSliderChange(evt) }}
                                    className='w-full md:w-60 top-4 range-slider h-5' />
                            </div>
                        </div>
                    </div>
                )}
            </div>
            <div className="overflow-auto">
                {loading ? (
                    <div className="space-y-2.5 p-2">
                        {Array.from({ length: 28 }).map((_, i) => (
                            <div key={i} className="animate-pulse flex w-full">
                                <div className="w-2/12 h-4 bg-gray-300 rounded mx-1"></div>
                                <div className="w-1/12 h-4 bg-gray-300 rounded mx-1"></div>
                                <div className="w-1/12 h-4 bg-gray-300 rounded mx-1"></div>
                                <div className="w-1/12 h-4 bg-gray-300 rounded mx-1"></div>
                                <div className="w-1/12 h-4 bg-gray-300 rounded mx-1"></div>
                                <div className="w-2/12 h-4 bg-gray-300 rounded mx-1"></div>
                                <div className="w-2/12 h-4 bg-gray-300 rounded mx-1"></div>
                            </div>
                        ))}
                    </div>
                ) : stockOptionData.length === 0 ? (
                    <div>
                        <p>No records found</p>
                    </div>
                ) : (
                    <div className={`overflow-x-auto mt-1.5 ${scrollHeight}`}>
                        <div className='p-2.5'>
                            {stockOptionData.map((data: OptionData, index: number) => (
                                <React.Fragment key={index}>
                                    <div>
                                        <div key={data.key} className="bg-white rounded-md shadow-md p-3 pl-2.5 w-full lg:w-1/3 mt-2">
                                            <div onClick={() => handleRowClick(index)} style={{ cursor: 'pointer' }}>
                                                <div className="flex justify-between items-center pb-2 border-b border-[#eeeeee]" >
                                                    <div className='flex items-center gap-2'>
                                                        <h2 className="text-sm font-semibold text-grey-slate">{data.shortContractName}</h2>
                                                        <span className="text-xs text-grey-raven">{formatDateTime(new Date(data.expirationDate), "DD-MMS-YYYY")}</span>
                                                    </div>
                                                    <div className='flex items-center gap-4'>
                                                        <span className="text-xs text-grey-raven">{data.createdAtAgo}</span>
                                                        {isOpen[index] ? (
                                                            <img src={Images.downarrow} alt='down arrow'></img>
                                                        ) : (
                                                            <img src={Images.leftarrow} alt='left arrow'></img>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="flex items-center gap-2 my-3 justify-between">
                                                    <div className='gap-3 flex justify-center items-center'>
                                                        <div>
                                                            <p className='text-[10px] text-grey-raven'>AI Score</p>
                                                        </div>
                                                        {/* AI Score Sections */}
                                                        {/* OpenAI Score */}
                                                        {data.openAiEnabled && (
                                                            <div className="relative inline-flex items-center">
                                                                <div className="bg-[#00B0871A] px-2 rounded-sm border border-green-persian leading-[14px]">
                                                                    <span className="text-grey-slate font-semibold text-[10px] font-poppins">{Math.round(data.openAiScore)}</span>
                                                                </div>
                                                                <div className="absolute top-0 rounded-sm right-0 -translate-y-1/2 translate-x-1/2 bg-green-persian text-white font-medium flex items-center justify-center w-3.5 h-3.5 ">
                                                                    <img src={Images.chatgpt} className='w-3 h-3' alt="Chat GPT" />
                                                                </div>
                                                            </div>
                                                        )}
                                                        {/* xAi Score */}
                                                        {data.xAiEnabled && (
                                                            <div className="relative inline-flex items-center">
                                                                <div className="bg-[#00B08733] px-2 rounded-sm border border-green-persian leading-[14px]">
                                                                    <span className="text-grey-slate font-semibold text-[10px] font-poppins">{Math.round(data.xAiScore)}</span>
                                                                </div>
                                                                <div className="absolute top-0 rounded-sm right-0 -translate-y-1/2 translate-x-1/2 bg-green-persian text-white font-medium flex items-center justify-center w-[14px] h-[14px] text-[9px]">
                                                                    <img src={Images.xai} className='w-[13px] h-[13px]' alt="xAi Grok" />
                                                                </div>
                                                            </div>
                                                        )}
                                                        {/* Significance Score */}
                                                        <div className="relative inline-flex items-center">
                                                            <div className="bg-[#00B0874D] px-2 rounded-sm border border-green-persian leading-[14px]">
                                                                <span className="text-grey-slate font-semibold text-[10px] font-poppins">{Math.round(data.significanceScore)}</span>
                                                            </div>
                                                            <div className="absolute top-0 rounded-sm right-0 -translate-y-1/2 translate-x-1/2 bg-green-persian text-white font-medium flex items-center justify-center w-[14px] h-[14px] text-[9px] leading-none">
                                                                <img src={Images.aiwhite} className='w-2.5' alt="xAi Grok" />
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* Share Button */}
                                                    <div className='w-4 cursor-pointer' onClick={(event) => handleSharePopup(event, data)}>
                                                        <img src={Images.shareicon} alt="share-icon" />
                                                    </div>

                                                    {/* Share Popup */}
                                                    {showSharePopup && (
                                                        <div className="fixed inset-0 flex items-center justify-center bg-black/5 z-50"
                                                            onClick={(event) => handleSharePopup(event, data)}
                                                        >
                                                            <div className="bg-black text-white p-3 rounded-2xl mx-2 shadow-md relative">
                                                                {/* Apple Logo & Title */}
                                                                <div className="flex items-center justify-between">
                                                                    <div className="flex items-center gap-6">
                                                                        <div className='w-8'>
                                                                            <img
                                                                                src={imageUrl}
                                                                                alt="image logo"
                                                                                className="w-full"
                                                                            />
                                                                        </div>
                                                                        <div>
                                                                            <h2 className="text-lg font-bold text-start">
                                                                                {contractType === "Call" ? "BUY" : "SELL"} {parentStockSymbol}
                                                                            </h2>
                                                                            <p className="text-gray-400 text-xs text-start">{companyName}</p>
                                                                        </div>
                                                                    </div>
                                                                    <div className='text-end'>
                                                                        <p className="text-xl font-bold text-[#68BB28]">
                                                                            {potentialGain.toFixed(2)}%
                                                                        </p>
                                                                        <p className='text-gray-400 text-xs'>Potential Gain </p>
                                                                    </div>
                                                                </div>
                                                                <div className="flex items-center gap-1.5 mt-4">
                                                                    <div className="flex flex-col bg-black border border-[#474747] rounded-[10px] py-2 px-4 w-1/2 text-start">
                                                                        <p className="text-gray-400 text-xs">Spot Price:</p>
                                                                        <p className=" font-bold text-lg mt-1.5">${formatPrice(spotPrice.toFixed(2))}</p>
                                                                    </div>
                                                                    <div className="absolute left-1/2 transform -translate-x-1/2 bg-black border border-[#474747] text-[#474747] p-2 rounded-full flex items-center justify-center w-7 h-7">
                                                                        →
                                                                    </div>
                                                                    <div className="flex flex-col bg-black border border-[#474747] rounded-[10px] py-2 px-4 w-1/2 text-start">
                                                                        <p className="text-gray-400 text-xs">Target:</p>
                                                                        <div className="flex items-center space-x-2 mt-1.5">
                                                                            <p className="text-lg font-bold ">${formatPrice(spotTargetPrice.toFixed(2))}</p>
                                                                            <span
                                                                                className={`text-white text-[10px] py-0.5 px-1.5 rounded-lg flex items-center leading-3 ${spotPercentageGain < 0 ? 'bg-red-700' : 'bg-[#68BB28]'
                                                                                    }`}>
                                                                                {spotPercentageGain > 0 ? '▲' : '▼'} {spotPercentageGain.toFixed(2)}%
                                                                            </span>
                                                                        </div>

                                                                    </div>
                                                                </div>

                                                                <div className='border border-[#474747] rounded-[10px] p-2 mt-4'>
                                                                    <div className='text-start'>
                                                                        <p className="text-gray-400 text-xs">Option: </p>
                                                                        <p className=" font-bold text-sm mt-1">{contractName}</p>
                                                                    </div>
                                                                    <div className="flex items-center gap-1.5 mt-2">
                                                                        <div className="flex flex-col bg-black border border-[#474747] rounded-[10px] py-2 px-4 w-1/2 text-start">
                                                                            <p className="text-gray-400 text-xs">Current</p>
                                                                            <p className=" font-bold text-lg mt-1.5">${formatPrice(optionPrice.toFixed(2))}</p>
                                                                        </div>
                                                                        <div className="absolute left-1/2 transform -translate-x-1/2 bg-black border border-[#474747] text-[#474747] p-2 rounded-full flex items-center justify-center w-7 h-7">
                                                                            →
                                                                        </div>
                                                                        <div className="flex flex-col bg-black border border-[#474747] rounded-[10px] py-2 px-4 w-1/2 text-start">
                                                                            <p className="text-gray-400 text-xs">Target:</p>
                                                                            <div className="flex items-center space-x-2 mt-1.5">
                                                                                <p className="text-lg font-bold ">${formatPrice(optionTargetPrice.toFixed(2))}</p>
                                                                                <span className={`text-white text-[10px] py-0.5 px-1.5 rounded-lg flex items-center leading-3 ${optionPercentageGain < 0 ? 'bg-red-700' : 'bg-[#68BB28]'}`}>
                                                                                    {optionPercentageGain > 0 ? '▲' : '▼'} {optionPercentageGain.toFixed(2)}%
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                {/* Extra Details Section */}
                                                                <div className="mt-4 flex justify-between">
                                                                    <div className='text-start w-1/2'>
                                                                        <p className="text-xs font-bold">Why This Call?</p>
                                                                        <p className="text-gray-400 text-[9px] mt-1">
                                                                            Today's Option Invested: <span className="text-white">${formatPrice(todayOptionInvested.toFixed(2))}</span>
                                                                        </p>
                                                                        <p className="text-gray-400 text-[9px] mt-1">
                                                                            Today's Contracts Added:{" "}
                                                                            <span className="text-white">${formatPrice(todayOptionInvested.toFixed(2))}<span className={`${todayContractPercentage < 0 ? 'text-red-700' : 'text-[#68BB28]'}`}> ({todayContractPercentage}%)</span></span>
                                                                        </p>
                                                                        <p className="text-gray-400 text-[9px] mt-1">
                                                                            Today's Put Call Ratio of : {" "}
                                                                            <span className="text-white">({parentStockSymbol})  ${formatPrice(todayPutCallRatio.toFixed(2))} <span className={`${pcr < 0 ? 'text-red-700' : 'text-[#68BB28]'}`}> (PCR {pcr.toFixed(2)}%)</span></span>
                                                                        </p>
                                                                    </div>
                                                                    <div className="w-px mx-2 bg-gray-500"></div>
                                                                    <div className="flex items-start w-1/2 gap-2">
                                                                        <div className='text-start'>
                                                                            <p className="text-[9px] text-white">Get More Calls in Real-Time!</p>
                                                                            <p className='text-[9px] text-gray-400'>Scan the QR Code to Join Our Discord</p>
                                                                        </div>
                                                                        <div>
                                                                            <QRCode
                                                                                className="p-0.5 !h-auto !w-auto !max-w-[66px] max-h-[66px] rounded-none"
                                                                                value="https://discord.gg/WfaxVXbNdu"
                                                                                bgColor="#FFFFFF"
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                                <div className="overflow-x-auto rounded-lg">
                                                    <table className="w-full text-[10px] border-collapse">
                                                        <thead className="sticky top-0 border-b border-[#eeeeee]">
                                                            <tr className="text-gray-700 text-center">
                                                                <th className="font-normal pt-0 p-1.5 pl-0.5 text-left border-r text-grey-slate">Price</th>
                                                                <th className="font-normal pt-0 p-1.5 text-grey-raven">Entry</th>
                                                                <th className="font-normal pt-0 p-1.5 text-grey-raven">Target</th>
                                                                <th className="font-normal pt-0 p-1.5 border-r text-grey-raven">Stop loss</th>
                                                                <th className="font-normal pt-0 p-1.5 text-grey-raven">Volume</th>
                                                                <th className="font-normal pt-0 p-1.5 text-grey-raven">Premium</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <div className='w-full h-2.5'></div>
                                                            <tr className="text-xs font-medium text-center">
                                                                <td className="px-1.5 pl-0.5 w-14">
                                                                    <span className='bg-[#03314B4D] border border-grey-slate p-0.5 w-[85%] text-center block rounded-sm text-[8px] text-grey-slate font-medium leading-[7px] mb-2'>OPTION</span>
                                                                    <span className='bg-[#6C727F4D] border border-grey-raven rounded-sm w-[85%] text-center block p-0.5 text-[8px] text-grey-raven font-medium  leading-[7px]'>SPOT</span>
                                                                </td>
                                                                <td className="font-medium px-1.5 border-r">
                                                                    <span className='text-grey-slate block mb-2'>${formatPrice(data.spotPrice.toFixed(2))}</span>
                                                                    <span className='text-grey-raven'>${formatPrice(data.optionPrice.toFixed(2))}</span>
                                                                </td>
                                                                <td className="font-medium px-1.5 border-r">
                                                                    <span className='text-grey-slate block mb-2'>${formatPrice(data.optionTargetPrice.toFixed(2))}</span>
                                                                    <span className='text-grey-raven'>${formatPrice(data.spotTargetPrice.toFixed(2))}</span>
                                                                </td>
                                                                <td className="font-medium px-1.5 border-r">
                                                                    <span className='text-grey-slate block mb-2'>${formatPrice(data.optionStopLossPrice.toFixed(2))}</span>
                                                                    <span className='text-grey-raven'>${formatPrice(data.spotStopLossPrice.toFixed(2))}</span>
                                                                </td>
                                                                <td className="font-medium px-1.5 border-r">
                                                                    <span className='text-grey-slate block mb-2'>{formatPrice(data.contractVolume)}</span>
                                                                    <span className='text-grey-raven'>{formatPrice(data.spotVolume)}</span>
                                                                </td>
                                                                <td className="text-gray-800 px-1.5">
                                                                    <span className='text-grey-slate block mb-2'>${formatPrice(data.optionPremium)}</span>
                                                                    <span className='text-grey-raven'>${formatPrice(data.spotPremium)}</span>
                                                                </td>
                                                            </tr>
                                                            {/* <tr className='text-xs text-grey-raven font-medium text-center'>
                                <td className="p-1.5">
                                    <span className='bg-[#6C727F4D] border border-grey-raven rounded-sm w-full text-center block p-0.5 text-[8px] text-grey-raven font-medium  leading-[11px]'>SPOT</span>
                                </td>
                                <td className="font-medium p-1.5 border-r">$12.27</td>
                                <td className="font-medium p-1.5 border-r">$14.9</td>
                                <td className="font-medium p-1.5 border-r">$80</td>
                                <td className="font-medium p-1.5 border-r">363k</td>
                                <td className="p-1.5">$800M</td>
                            </tr> */}
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <div className="flex justify-between gap-1 text-sm text-left pt-2.5">
                                                    <div className='pl-0.5'>
                                                        <span className="font-medium block text-grey-raven text-[10px]">Delta</span>
                                                        <span className='text-xs text-black font-medium'>{data.optionDelta.toFixed(2)}</span>
                                                    </div>
                                                    <div>
                                                        <span className="font-medium block text-grey-raven text-[10px]">IV</span>
                                                        <span className='text-xs text-black font-medium'>{(data.impliedVolatility !== 0) ? data.impliedVolatility : '-'}</span>
                                                    </div>
                                                    <div>
                                                        <span className="font-medium block text-grey-raven text-[10px]">OI</span>
                                                        <span className='text-xs text-black font-medium'>{(data.openInterest !== 0) ? formatNumber(data.openInterest) : '-'}</span>
                                                    </div>
                                                    <div>
                                                        <span className="font-medium block text-grey-raven text-[10px]">OI Chan.</span>
                                                        <span
                                                            className={`text-xs text-green-persian font-medium ${data.openInterestChange === 0 ? 'text-grey-slate'
                                                                : data.openInterestChange < 0 ? 'text-red-500' : 'text-green-persian'
                                                                }`}>
                                                            {(data.openInterestChange !== 0) ? formatNumber(data.openInterestChange) : '-'}
                                                        </span>
                                                    </div>
                                                    <div>
                                                        <span className="font-medium block text-grey-raven text-[10px]">Highest OI</span>
                                                        <span
                                                            className={`block text-xs text-black font-medium ${data.highestOpenInterestContractName
                                                                ? data.contractType === data.highestOpenInterestContractType
                                                                    ? 'text-green-persian'
                                                                    : 'text-red-500'
                                                                : 'text-grey-slate'
                                                                }`}
                                                        >
                                                            {data.highestOpenInterestContractName ? data.highestOpenInterestContractName : '-'}
                                                        </span>
                                                        <span
                                                            className={`block text-xs text-black font-medium ${data.highestOpenInterest
                                                                ? data.contractType === data.highestOpenInterestContractType
                                                                    ? 'text-green-persian'
                                                                    : 'text-red-500'
                                                                : 'text-grey-slate'
                                                                }`}
                                                        >
                                                            {data.highestOpenInterest ? formatNumber(data.highestOpenInterest) : '-'}
                                                        </span>
                                                    </div>
                                                    <div>
                                                        <span className="font-medium block text-grey-raven text-[10px]">Type</span>
                                                        <span className={`${(data.moneyness === 'ATM')
                                                            ? 'text-orange-carrot text-xs from-neutral-500'
                                                            : (data.moneyness === 'OTM')
                                                                ? 'text-red-persian text-xs'
                                                                : (data.moneyness === 'ITM')
                                                                    ? 'text-green-persian text-xs'
                                                                    : ''
                                                            }`}>{data.moneyness}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            {/*TradingView Chart */}
                                            {isLoading[index] ? (
                                                <tr>
                                                    <td colSpan={14} className="p-4 text-left">
                                                        <div className="space-y-4">
                                                            {Array.from({ length: 5 }).map((_, i) => (
                                                                <div key={i} className="animate-pulse flex w-full">
                                                                    <div className="w-full h-5 bg-gray-300 rounded"></div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </td>
                                                </tr>
                                            ) : (
                                                expandedRowIndex === index && (
                                                    <div>
                                                        {/* Tab Navigation */}
                                                        <div className="flex space-x-4 border-b border-gray-200 my-2">

                                                            <button
                                                                className={`px-4 py-2 text-sm font-medium ${activeTab === "other"
                                                                    ? "text-grey-slate border-b-2 border-grey-slate"
                                                                    : "text-gray-600 hover:text-grey-slate"
                                                                    }`}
                                                                onClick={() => setActiveTab("other")}
                                                            >
                                                                Top Options
                                                            </button>
                                                            <button
                                                                className={`px-4 py-2 text-sm font-medium ${activeTab === "chart"
                                                                    ? "text-grey-slate border-b-2 border-grey-slate"
                                                                    : "text-gray-600 hover:text-grey-slate"
                                                                    }`}
                                                                onClick={() => setActiveTab("chart")}
                                                            >
                                                                Chart
                                                            </button>
                                                        </div>
                                                        {/* Tab Content */}
                                                        <div>
                                                            {activeTab === "chart" && (
                                                                <div className={`text-left ${isGuestUser.current ? 'blur-md pointer-events-none' : ''}`}>
                                                                    <div className="mt-4 mobile-chart">
                                                                        <TradingViewChart
                                                                            symbol={
                                                                                selectedTradingType === "spot"
                                                                                    ? stockOptionData[index]?.parentStockSymbol
                                                                                    : selectedTradingType === "option"
                                                                                        ? stockOptionData[index]?.tradingViewStockSymbol
                                                                                        : "SAVA"
                                                                            }
                                                                        />
                                                                    </div>
                                                                </div>
                                                            )}
                                                            {activeTab === "other" && (
                                                                <div className={` text-gray-700 ${isGuestUser.current ? 'blur-md pointer-events-none' : ''}`}>
                                                                    <div>
                                                                        <div className="bg-white w-full mt-4">
                                                                            <div className="flex justify-between items-center pb-2 border-b border-[#eeeeee]">
                                                                                <div className="flex items-center gap-2">
                                                                                    <h2 className="text-xs font-semibold text-grey-slate">
                                                                                        Top Options by Volume (Today's)
                                                                                    </h2>
                                                                                </div>
                                                                            </div>
                                                                            <div className="overflow-x-auto rounded-lg my-3">
                                                                                {todayTopContractData.length > 0 ? (
                                                                                    <table className="w-full text-sm border-collapse">
                                                                                        <thead className="sticky text-[10px] top-0 border-b border-[#eeeeee]">
                                                                                            <tr className="text-black font-semibold text-center">
                                                                                                <th className="font-semibold pt-0 p-1.5 border-r text-left">
                                                                                                    Symbol
                                                                                                </th>
                                                                                                <th className="font-semibold pt-0 p-1.5">Volume</th>
                                                                                                <th className="font-semibold pt-0 p-1.5">Premium</th>
                                                                                            </tr>
                                                                                        </thead>
                                                                                        <tbody>
                                                                                            {todayTopContractData.map((contract, i) => (
                                                                                                <tr key={i} className="text-xs font-medium text-center">
                                                                                                    <td className="font-medium px-1.5 pt-2.5 border-r text-left">
                                                                                                        <span className="text-grey-raven block">{contract.contractName}</span>
                                                                                                    </td>
                                                                                                    <td className="font-medium px-1.5 pt-2.5 border-r">
                                                                                                        <span className="text-grey-raven block">{(contract.totalVolume !== 0) ? formatPrice(contract.totalVolume) : '-'}</span>
                                                                                                    </td>
                                                                                                    <td className="text-gray-800 px-1.5 pt-2.5">
                                                                                                        <span className="text-grey-raven block">${(contract.totalPremium !== 0) ? formatPrice(contract.totalPremium) : '-'}</span>
                                                                                                    </td>
                                                                                                </tr>
                                                                                            ))}
                                                                                        </tbody>
                                                                                    </table>
                                                                                ) : (
                                                                                    <p className="text-center text-gray-500 text-xs">No data found</p>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    {
                                                                        /* Recent Best Contracts */
                                                                    }
                                                                    <div>
                                                                        <div className="bg-white w-full mt-4">
                                                                            <div className="flex justify-between items-center pb-2 border-b border-[#eeeeee]">
                                                                                <div className="flex items-center gap-2">
                                                                                    <h2 className="text-xs font-semibold text-grey-slate">
                                                                                        Top Options by Volume (Last 5 Days)
                                                                                    </h2>
                                                                                </div>
                                                                            </div>
                                                                            <div className="overflow-x-auto rounded-lg my-3">
                                                                                {topRecentContractData.length > 0 ? (
                                                                                    <table className="w-full text-sm border-collapse">
                                                                                        <thead className="sticky text-[10px] top-0 border-b border-[#eeeeee]">
                                                                                            <tr className="text-black font-semibold text-center">
                                                                                                <th className="font-semibold pt-0 p-1.5 border-r text-left">
                                                                                                    Symbol
                                                                                                </th>
                                                                                                <th className="font-semibold pt-0 p-1.5">Volume</th>
                                                                                                <th className="font-semibold pt-0 p-1.5">Premium</th>
                                                                                            </tr>
                                                                                        </thead>
                                                                                        <tbody>
                                                                                            {topRecentContractData.map((contract, i) => (
                                                                                                <tr key={i} className="text-xs font-medium text-center">
                                                                                                    <td className="font-medium px-1.5 pt-2.5 border-r text-left">
                                                                                                        <span className="text-grey-raven block">{contract.contractName}</span>
                                                                                                    </td>
                                                                                                    <td className="font-medium px-1.5 pt-2.5 border-r">
                                                                                                        <span className="text-grey-raven block">{(contract.totalVolume !== 0) ? formatPrice(contract.totalVolume) : '-'}</span>
                                                                                                    </td>
                                                                                                    <td className="text-gray-800 px-1.5 pt-2.5">
                                                                                                        <span className="text-grey-raven block">${(contract.totalPremium !== 0) ? formatPrice(contract.totalPremium) : '-'}</span>
                                                                                                    </td>
                                                                                                </tr>
                                                                                            ))}
                                                                                        </tbody>
                                                                                    </table>
                                                                                ) : (
                                                                                    <p className="text-center text-gray-500 text-xs">No data found</p>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>

                                                        {showSignInPopup && (
                                                            <div className="absolute inset-0 flex items-center justify-center bg-black/50 z-50 ">
                                                                <RowSignInPopup index={index} onClose={handleRowClick} />
                                                            </div>
                                                        )}
                                                    </div>
                                                )
                                            )}
                                        </div>
                                    </div>
                                </React.Fragment>
                            ))}
                        </div>
                    </div>
                )}
            </div>
            <Pagination
                total={totalItems}
                current={currentPage}
                pageSize={pageSize}
                onChange={handlePageChange}
                className="w-full rounded-md justify-end p-2 mt-1 pagination-table"
                align='end'
                showSizeChanger={false}
                showTotal={(total, range) => `${range[0]}-${range[1]} of ${total}`}
            />
        </div>
    );
};

export default Mitmobile;